window.savedTheme = function () {
  const local = localStorage.getItem("louvorpro-theme-config");
  const systemDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return local || (systemDark ? "dark" : "light");
};
